import Service from "./service.model";

export default class ServiceGroup {

    constructor(data) {
        this.id = null;
        this.name = null;
        this.services = [];

        if (data) {
            Object.assign(this, data);

            if (this.services) {
                this.services = this.services.map((serviceData)=> {
                    return new Service(serviceData);
                });
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/servicegroup.model.js